
import { useState } from "react"
import { hunsOption, hunsUpgrade } from "../../../../data/upgrade/huns"
import ListSelect from "../../ListSelect"
import Btn from "../../Btn"

const HunsUpgrade = (props) => {
    const selectList = hunsOption
    const lvl = Array.from({ length: 20 }, (_, index) => ({ id: index + 1, name: `Level ${index + 1}` }));

    const [selectValue, setSelectValue] = useState({name:"", lvl:"1"})
    const handleSelectName = event => {
        setSelectValue(prevState => ({ name: event.target.value, lvl: prevState.lvl }));
    } 
    const handleSelectLvl = event => {
        setSelectValue(prevState => ({ ...prevState, lvl: event.target.value }));
    }
    
      
    function vypis(){
        const selectedHunUpgrade = hunsUpgrade[selectValue.name - 1][selectValue.lvl-1]
        const item =[{id:1,
                      name: selectedHunUpgrade.name + " " + selectedHunUpgrade.level ,
                      wood: selectedHunUpgrade.wood,
                      clay: selectedHunUpgrade.clay,
                      iron: selectedHunUpgrade.iron,
                      crop: selectedHunUpgrade.crop,
                      all: selectedHunUpgrade.all}]
        props.addItem(item[0])
    }
    

    
    return(
        <div>
            <ListSelect label="...choose a trop" selectList={selectList} handleSelectValue={handleSelectName} />
            <ListSelect label="...choose a level" selectList={lvl} handleSelectValue={handleSelectLvl}/>
            {selectValue ? (
            <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />
        ) : null}

        </div>
    )
}
export default HunsUpgrade